// Export the Component Definition for use in Contentful Studio
export {CatalogInterstitialContentfulComponentDefinition} from './CatalogInterstitialContentfulDefinition';
export type {CatalogInterstitialProps} from './CatalogInterstitial';
export {default} from './CatalogInterstitial';
